import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const ACOES_CONTATO_LEAD: Record<string, string> = {
  LIGACAO_TENTADA: "Ligação tentada",
  LIGACAO_REALIZADA: "Ligação atendida",
  WHATSAPP_CONVERSA: "WhatsApp",
  EMAIL_ENVIADO: "E-mail",
  SMS_ENVIADO: "SMS",
  APRESENTACAO_ENVIADA: "Apresentação",
  PROPOSTA_ENVIADA: "Proposta",
  RETORNO_ENVIADO: "Retorno",
  FECHAMENTO_ENVIADO: "Fechamento",
};

export interface TentativaContatoLead {
  acao: string;
  created_at: string;
}

export function useTentativasContatoLead(leadId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: ["lead", "tentativas-contato", leadId],
    enabled: enabled && !!leadId,
    staleTime: 0,
    queryFn: async (): Promise<TentativaContatoLead[]> => {
      const { data, error } = await supabase
        .from("leads_carteira_historico")
        .select("acao, created_at")
        .eq("lead_id", leadId as string)
        .in("acao", Object.keys(ACOES_CONTATO_LEAD))
        .order("created_at", { ascending: false })
        .limit(200);
      if (error) throw error;
      return (data || []) as TentativaContatoLead[];
    },
  });
}
